import React, { useState, useEffect } from "react";
import { FaCheck } from "react-icons/fa";
import PopupCard from "./ProfilePopup";

const formatDate = (inputDate) => {
  const date = new Date(inputDate);
  const day = date.getDate().toString().padStart(2, "0");
  const month = new Intl.DateTimeFormat("en-US", { month: "short" }).format(
    date
  );
  return `${day} ${month}`;
};

const Home = ({ handleLogout }) => {  
    const baseUrl = process.env.REACT_APP_BASE_URL;
  const token = localStorage.getItem("EXPERT_AUTH_TOKEN");

   const expertDetails = JSON.parse(localStorage.getItem("EXPERT_INFO"));
   console.log("user details", JSON.stringify(expertDetails));

  const [completedSessions, setCompletedSessions] = useState([]);
  const [upcomingSessions, setUpcomingSessions] = useState([]);
  
  const [profilePopup, setProfilePopup] = useState(false);


  const handleFeedbackClick = (name) => {
    setProfilePopup(true);
  };

  const handleProfilePopupClick = () => {
    setProfilePopup(false);
  };

  const getMeetingsData = async () => {
    try {
      const response = await fetch(
        `${baseUrl}/api/session/upcoming/${expertDetails._id}`,
        {
          method: "GET",
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      if (response.ok) {
        const data = await response.json();
        console.log(data.data);
        setUpcomingSessions(data.data);
      } else {
        console.error("Error fetching meetings data:", response.status);
      }
    } catch (error) {
      console.error("Error fetching meetings data:", error);
    }
  };

  useEffect(() => {
    getMeetingsData();
  }, []);

  return (
    <div className="p-5 lg:pl-16 lg:pt-7 flex justify-center flex-col">
      <nav className="text-white flex justify-between items-center">
        <div className="pl-5 bg-gradient-to-r from-cyan-600 to-red-400 bg-clip-text text-transparent leading-tight font-bold text-4xl">
          {expertDetails.name}
        </div>

        <div className="flex items-center">
          <a href="/">
            <div className="jump-to-website mr-5 px-5 py-2 bg-gradient-to-r from-cyan-600 to-red-400 rounded-md font-semibold text-white cursor-pointer hover:bg-gradient-to-r hover:from-red-400 hover:to-cyan-600">
              Jump to Website
            </div>
          </a>
          <div
            onClick={handleFeedbackClick}
            className="popup-container flex items-center cursor-pointer h-full"
          >
            <img
              className="h-12 w-12 rounded-full cursor-pointer"
              src={expertDetails.profileImageUrl}
              alt="Profile"
            />
          </div>

          {profilePopup && (
            <PopupCard
              expertDetails={expertDetails}
              handleLogout={handleLogout}
              onClose={handleProfilePopupClick}
            />
          )}
        </div>
      </nav>
      <div className="ml-5 flex text-xs space-x-2 ">
        {/* <p className="bg-gray-100 border border-black px-2 py-1 rounded-lg"> {expertDetails.session.category}</p> */}
        <p className="bg-gray-100 border border-blue-500 px-2 py-1 rounded-lg">
          Web Devlopment
        </p>
        <p className="bg-gray-100 border border-blue-500 px-2 py-1 rounded-lg">
          ReactJs
        </p>
      </div>

      <div className="flex">
        <div className="bg-white w-2/3 m-5 p-4 border rounded-lg shadow-md">
          <h2 className="text-2xl ml-5 font-bold mb-4">Upcoming Sessions</h2>
          <div className="overflow-y-scroll max-h-80">
            {upcomingSessions.length === 0 ? (
              <p className="text-gray-600 ml-5">
                All the upcoming sessions will be shown here with details.
              </p>
            ) : (
              upcomingSessions.reverse().map((session) => (
                <div
                  key={session._id}
                  className="rounded-md bg-white border border-gray-400 p-5 m-5"
                >
                  <div className="flex items-center mb-2">
                    <div className="w-full flex justify-between items-start">
                      <div className="problemsolver md:flex justify-center items-center">
                        <img
                          src={
                            session.bookedBy.profileImageUrl
                              ? session.bookedBy.profileImageUrl
                              : "https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
                          }
                          alt="Profile"
                          className="w-14 h-14 rounded-full mr-3"
                        />

                        <div className="">
                          <h1 className="text-xl">{session.bookedBy.name}</h1>
                          <span className="text-sm bg-blue-100 px-1 py-1 rounded ">
                            {session.sessionDetails.topic}
                          </span>
                        </div>
                      </div>

                      <p className="text-gray-600">
                        <span className="">{formatDate(session.date)}</span>{" "}
                        {session.time}
                      </p>
                    </div>
                  </div>
                  <h3 className="bg-white p-4 mt-5 rounded-md shadow text-lg font-semibold">
                    {session.question}
                  </h3>
                  <button
                    className="bg-blue-500 text-white px-4 py-2 rounded-md mt-3"
                    onClick={() => window.open(session.meetLink, "_blank")}
                  >
                    Join Session
                  </button>
                </div>
              ))
            )}
          </div>
        </div>

        <div className="bg-white w-1/3 p-5 border m-5 rounded-md shadow-md">
          <h2 className="text-2xl font-bold mb-4">Completed Sessions</h2>
          {completedSessions.length === 0 ? (
            <p className="text-gray-600">
              All the completed sessions will be shown here with details.
            </p>
          ) : (
            completedSessions.map((session) => (
              <div
                key={session.id}
                className="bg-white p-4 mb-2 rounded-md shadow"
              >
                <h3 className="text-lg font-semibold">{session.title}</h3>
                <p className="text-gray-600">{session.date}</p>
              </div>
            ))
          )}
        </div>
      </div>
      <div className="notice mx-5 p-5 mt-20 text-2xl border  border-red-600 rounded-lg">
        <h1 className="text-3xl text-red-500 "> Attention:</h1>
        <p>
          Currently, we are only providing sessions in scheduled formats. Soon,
          we will release in-built advanced video call for instant sessions in
          real time. After this, there will not be any requirement to tell your
          availability to users and keep remembering the date and time for the
          session. Instant video sessions in real-time will come with great
          features like automated recording, audio transcript, advanced in-built
          tools for quality problem-solving experience and session summary. This
          will increase your earning potential exponentially by drastically
          reducing your time and effort.
        </p>
      </div>
      <div className=" mx-5 px-5 py-20 rounded-lg ">
        <h1 className="text-2xl ">
          As a problem solver, your responsibility is to solve users'
          conceptual, technical and practical STEM problems to give them the
          best user experience in your selected topic.
        </h1>
        <ul className="mt-6 space-y-2 text-lg">
          <li className="flex items-center mb-2">
            <FaCheck className="text-green-500 mr-2" />
            You shall be eligible to apply for another topic once you cross ten
            sessions.
          </li>
          <li className="flex items-center mb-2">
            <FaCheck className="text-green-500 mr-2" />
            Complete ten sessions with an average of 4 plus rating to increase
            your session price.
          </li>

          <li className="flex items-center mb-2">
            <FaCheck className="text-green-500 mr-2" />
            Get hands on the most advanced video solution to make your
            experience smoother.
          </li>
          <li className="flex items-center mb-2">
            <FaCheck className="text-green-500 mr-2" />
            Continually update your availability so users find a spot for you.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Home;
